import type { ReactNode } from "react";

import styles from "./styles.module.css";

interface SourceNoteProps {
  label: string;
  children: ReactNode;
}

export function SourceNote({ label, children }: SourceNoteProps) {
  return (
    <aside className={styles.note} data-reveal>
      <span className={styles.label}>{label}</span>
      <p>{children}</p>
    </aside>
  );
}

export default SourceNote;
